import { render, staticRenderFns } from "./WorkshopRequestsList.vue?vue&type=template&id=5baa9811&scoped=true&"
import script from "./WorkshopRequestsList.vue?vue&type=script&lang=js&"
export * from "./WorkshopRequestsList.vue?vue&type=script&lang=js&"
import style0 from "./WorkshopRequestsList.vue?vue&type=style&index=0&id=5baa9811&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5baa9811",
  null
  
)

export default component.exports